<template>
    <v-password-field v-model="passwordConfirm" v-bind="{ ...$attrs, rules }" @input="()=>{ $emit('input', passwordConfirm)}" />
</template>
<script>
import VPasswordField from "./v-password-field.vue";
export default {
    components: {
        VPasswordField,
    },
    props: {
        password: { type: String, default: null },
    },
    data: () => ({
        passwordConfirm: null,
    }),
    computed: {
        rules() {
            if(this.passwordConfirm && this.passwordConfirm == this.password){
                return [() => (this.passwordConfirm && this.passwordConfirm == this.password)]
            };
            
            return [ "비밀번호가 일치하지 않습니다"];
            // return [() => (this.passwordConfirm && this.passwordConfirm == this.password) || "비밀번호가 일치하지 않습니다"];
        },
    },
};
</script>